import $ from 'jquery';
import { Plugin } from '../Plugin';

require('jquery-validation');

const regexLanguageFormats = {
  en: {
    integer: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?$/,
    number: /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/,
  },
  de: {
    integer : /^(?:-?\d+|-?\d{1,3}(?:\.\d{3})+)?$/,
    number : /^(?:-?\d+|-?\d{1,3}(?:\.\d{3})+)?(?:,\d+)?$/
  },
  de_ch : {
    integer : /^(?:-?\d+|-?\d{1,3}(?:'\d{3})+)?$/,
    number : /^(?:-?\d+|-?\d{1,3}(?:'\d{3})+)?(?:\.\d+)?$/
  }
};

if (typeof $.validator !== 'undefined') {
  const languageKey = document.documentElement.lang.toLowerCase();
  const regexFormats = regexLanguageFormats.hasOwnProperty(languageKey) ? regexLanguageFormats[languageKey] : regexLanguageFormats.en;

  // Add custom messages to validator
  if (typeof validationMessages === 'object') {
    $.extend($.validator.messages, validationMessages);
  }

  // Override required rule to handle null-Option
  $.validator.methods.required = function (value, element, param) {

    // Check if dependency is met
    if (!this.depend(param, element)) {
      return 'dependency-mismatch';
    }
    if (element.nodeName.toLowerCase() === 'select') {

      // Could be an array for select-multiple or a string, both are fine this way
      const val = $(element).val();
      return val && val.length > 0 && val !== 'null';
    }
    if (this.checkable(element)) {
      return this.getLength(value, element) > 0;
    }
    return value.length > 0;
  };

  // Add additional methods to validator
  $.validator.addMethod('regexp', function (value, element, param) {
    if (this.optional(element)) {
      return true;
    }
    if (typeof param === 'string') {
      param = new RegExp('^(?:' + param + ')$');
    }
    return param.test(value);
  }, 'Invalid format.');

  $.validator.addMethod('integer', function (value, element) {
    return this.optional(element) || regexFormats['integer'].test(value);
  }, $.validator.messages.integer);

  $.validator.addMethod('number', function (value, element) {
    return this.optional(element) || regexFormats['number'].test(value);
  }, $.validator.messages.number);
}

const NAME = 'validate';
const formClasses = {
  error: 'has-danger',
  valid: 'has-success'
};

class Validate extends Plugin {
  getName() {
    return NAME;
  }

  static getDefaults() {
    return {
      errorClass: 'form-control-feedback',
      errorElement: 'small',
      errorPlacement: ($errorElement, $element) => {
        const $parentElement = $element.parent();
        if ($parentElement.hasClass('input-group')) {
          $parentElement.parent().append($errorElement);
        } else {
          $parentElement.append($errorElement);
        }
      },
      highlight: (element, errorClass, validClass) => {
        // add error highlighting to field
        $(element).closest('.form-group').removeClass(formClasses.valid).addClass(formClasses.error);
      },
      unhighlight: (element, errorClass, validClass) => {
        const $currentValidator = $(element).closest('form').data('validator'),
              value = $currentValidator.elementValue(element);

        if (value === '' || (element.nodeName.toLowerCase() === 'select' && value === 'null')) {
          // remove valid and error highlighting for empty optional field
          $(element).closest('.form-group').removeClass(formClasses.error + ' ' + formClasses.valid);
        } else {
          // add valid highlighting to field
          $(element).closest('.form-group').removeClass(formClasses.error).addClass(formClasses.valid);
        }
      }
    }
  }

  render() {
    if (typeof $.validator === 'undefined') {
      return;
    }

    this.$el.validate(this.options);
    this.$el.find('[data-plugin="select2"]').on(
      'select2:close',
      function (event) {
        $(this).valid();
      }
    );
  }
}

Plugin.register(NAME, Validate);

export default Validate;
